import React, { useState, useEffect } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import PandaPickLogo from "../../assets/icon.png";
import PandaPickLogoFull from "../../assets/pandalogo.png";

const SideBar = ({ onLogout }) => {


    useEffect(() => {
  const handleTabClose = () => {
    localStorage.clear();
  };

  window.addEventListener("beforeunload", handleTabClose);

  return () => {
    window.removeEventListener("beforeunload", handleTabClose);
  };
}, []);

    const auth = localStorage.getItem('user');
    const navigate = useNavigate();

    // Default: sidebar closed
    const [collapsed, setCollapsed] = useState(true);

    const logout = () => {
        onLogout();
        navigate('/login');
    };

    return (
        <aside
            className={`sidebar nav-ul-vertical ${
                collapsed ? 'sidebar-collapsed' : ''
            }`}
        >

            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center p-3 siderbar_inside">

                 {!collapsed && (
                    <div className='d-flex gap-2 align-items-center'>
                <img src={auth ? JSON.parse(auth).logo : ""} width={40} height={40}/>

               
                    <p className="m-0 sidebar-title text-white">
                        Welcome<br></br>
                        <b>{auth ? JSON.parse(auth).name : ""}</b>
                    </p>
                    </div>
                )}

                <button
                    type="button"
                    className="btn btn-sm btn-light"
                    onClick={() => setCollapsed(!collapsed)}
                    title={collapsed ? "Open Menu" : "Close Menu"}
                >
                    {collapsed ? "☰" : "✕"}
                </button>

            </div>


            {/* MENU */}
            {auth ? (

                <ul>

                    <li>
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) =>
                                isActive ? "active-menu" : ""
                            }
                            title='Dashboard'
                        >
                            <span className="menu-icon">🏠</span>
                            {!collapsed && <span>Dashboard</span>}
                        </NavLink>
                    </li>


                    <li>
                        <NavLink
                            to="/add-employee"
                            className={({ isActive }) =>
                                isActive ? "active-menu" : ""
                            }
                            title='Add Employee'
                        >
                            <span className="menu-icon">➕</span>
                            {!collapsed && <span>Add Employee</span>}
                        </NavLink>
                    </li>


                    <li>
                        <NavLink
                            to="/employees"
                            className={({ isActive }) =>
                                isActive ? "active-menu" : ""
                            }
                            title='All Employees'
                        >
                            <span className="menu-icon">👥</span>
                            {!collapsed && <span>Employees</span>}
                        </NavLink>
                    </li>


                    <li>
                        <NavLink
                            to="/payroll"
                            className={({ isActive }) =>
                                isActive ? "active-menu" : ""
                            }
                            title='PayRoll'
                        >
                            <span className="menu-icon">💰</span>
                            {!collapsed && <span>PayRoll</span>}
                        </NavLink>
                    </li>


                    <li>
                        <NavLink
                            to="/update-profile"
                            className={({ isActive }) =>
                                isActive ? "active-menu" : ""
                            }

                            title='My Profile'
                        >
                            <span className="menu-icon">👤</span>
                            {!collapsed && <span>My Profile</span>}
                        </NavLink>
                    </li>


                    <li>
                        <Link
                            to="/login"
                            onClick={logout}
                        >
                            <span className="menu-icon">🚪</span>
                            {!collapsed && <span>Logout</span>}
                        </Link>
                    </li>

                </ul>

            ) : (

                <ul className="nav-ul">

                    <li className="nav-item">
                        <NavLink
                            to="/signup"
                            className={({ isActive }) =>
                                isActive ? "active-menu" : ""
                            }
                        >
                            <span className="menu-icon">📝</span>
                            {!collapsed && <span>Signup</span>}
                        </NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink
                            to="/login"
                            className={({ isActive }) =>
                                isActive ? "active-menu" : ""
                            }
                        >
                            <span className="menu-icon">🔑</span>
                            {!collapsed && <span>Login</span>}
                        </NavLink>
                    </li>

                </ul>

            )}

         
            <div className='position-absolute bottom-0'>
                {!collapsed ? (
               <img  src={PandaPickLogoFull}  alt="PandaPick" className='controllerlogo'/>
                )
                :(
                 <img  src={PandaPickLogo}  alt="PandaPick" className='controllerlogo'/>
                )
                }
            </div>

        </aside>
    );
};

export default SideBar;